export default "__VITE_ASSET__I1RJ8hpC__"